import script from "./editImprove.vue?vue&type=script&setup=true&lang=js"
export * from "./editImprove.vue?vue&type=script&setup=true&lang=js"

import "./editImprove.vue?vue&type=style&index=0&id=d60d0974&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d60d0974"]])

export default __exports__